import { useState, useEffect } from 'react';
import { categories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCategoriesOpen, setMobileCategoriesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 no-underline"
          >
            <span className="text-xl md:text-2xl font-bold tracking-tight font-heading">
              Kakobuy<span className="text-primary-500">Finds</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <a href="#categories" className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
              Kategorie
            </a>
            <a href="#about" className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
              O Nas
            </a>
            <Link to="/artykul/kakobuy-sheet-kompletny-przewodnik" className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap">
              Poradnik
            </Link>
            <a href="#cta" className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
              Kontakt
            </a>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 text-sm font-medium border border-foreground-300 text-foreground-800 rounded-full hover:bg-foreground-50 transition-all whitespace-nowrap cursor-pointer"
            >
              Kakobuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          <button
            onClick={() => { setMobileOpen(!mobileOpen); setMobileCategoriesOpen(false); }}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 cursor-pointer"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 max-h-[85vh] overflow-y-auto">
          <div className="px-6 py-4 flex flex-col gap-1">
            <a href="#categories" className="flex items-center gap-2 text-sm text-foreground-700 hover:text-foreground-950 py-2.5 px-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer" onClick={() => setMobileOpen(false)}>
              <i className="ri-apps-line text-foreground-500 w-5"></i>
              Kategorie
            </a>
            <a href="#about" className="flex items-center gap-2 text-sm text-foreground-700 hover:text-foreground-950 py-2.5 px-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer" onClick={() => setMobileOpen(false)}>
              <i className="ri-information-line text-foreground-500 w-5"></i>
              O Nas
            </a>
            <Link to="/artykul/kakobuy-sheet-kompletny-przewodnik" className="flex items-center gap-2 text-sm text-foreground-700 hover:text-foreground-950 py-2.5 px-2 rounded-lg hover:bg-background-100 transition-colors" onClick={() => setMobileOpen(false)}>
              <i className="ri-book-open-line text-foreground-500 w-5"></i>
              Poradnik
            </Link>
            <Link to="/artykul/cssbuy-vs-kakobuy-porownanie-spreadsheet" className="flex items-center gap-2 text-sm text-foreground-700 hover:text-foreground-950 py-2.5 px-2 rounded-lg hover:bg-background-100 transition-colors" onClick={() => setMobileOpen(false)}>
              <i className="ri-scales-line text-foreground-500 w-5"></i>
              Porównanie CSSBuy
            </Link>
            <Link to="/artykul/kakobuy-bezpieczne-zakupy-poradnik" className="flex items-center gap-2 text-sm text-foreground-700 hover:text-foreground-950 py-2.5 px-2 rounded-lg hover:bg-background-100 transition-colors" onClick={() => setMobileOpen(false)}>
              <i className="ri-shield-check-line text-foreground-500 w-5"></i>
              Bezpieczne Zakupy
            </Link>

            <div className="my-3 border-t border-background-200"></div>

            <button
              onClick={() => setMobileCategoriesOpen(!mobileCategoriesOpen)}
              className="flex items-center justify-between w-full text-sm font-semibold text-foreground-800 py-2.5 px-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <i className="ri-price-tag-3-line text-primary-500 w-5"></i>
                Kategorie Produktów (14)
              </span>
              <i className={`ri-arrow-down-s-line text-foreground-500 transition-transform ${mobileCategoriesOpen ? 'rotate-180' : ''}`}></i>
            </button>

            {mobileCategoriesOpen && (
              <div className="grid grid-cols-2 gap-1.5 px-1 pb-2">
                {categories.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setMobileOpen(false)}
                    className="flex items-center gap-2 text-xs text-foreground-600 hover:text-foreground-900 py-2 px-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
                  >
                    <i className={`${cat.icon} text-primary-500 text-sm w-4`}></i>
                    {cat.namePl}
                  </a>
                ))}
              </div>
            )}

            <div className="my-2 border-t border-background-200"></div>

            <div className="flex gap-2 pt-1 pb-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex-1 text-center px-3 py-2.5 text-sm font-medium border border-foreground-300 text-foreground-800 rounded-full hover:bg-foreground-50 transition-all whitespace-nowrap cursor-pointer"
              >
                Kakobuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex-1 text-center px-3 py-2.5 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}